import { Component, Injector, Input, OnInit } from '@angular/core';
import { map } from 'rxjs';
import _map from 'lodash/map';
import { HttpParams } from '@angular/common/http';
import { ListingBaseComponent } from '../base/listing-base.component';
import { SERVER_URL, USER_WALLET_BALANCE } from '../../constants/apis-list';
import { LOADIPHLPAPI } from 'dns';
import { lowerCase } from 'lodash';
import { FullWidth } from 'ag-grid-community/dist/lib/components/framework/componentTypes';
import { toQueryParams } from '../../utils';

@Component({
  selector: 'app-user-wallets',
  templateUrl: './user-wallets.component.html',
  styleUrls: ['./user-wallets.component.scss'],
})
export class UserWalletsComponent
  extends ListingBaseComponent
  implements OnInit
{
  @Input() details: any;

  public user: any;

  params: HttpParams = new HttpParams();

  WALLETS?: any[] = [];
  PARTNER_NAME?: string;
  INITIAL_FILTERS: string;
  WALLET_URL: string;
  DISPLAY_FIELDS: any;
  HAS_DISPLAY_FIELDS?: boolean;

  constructor(injector: Injector) {
    super(injector);

    this.user = this.userService.user;
    this.PARTNER_NAME = lowerCase(this.user?.partner?.name);

    const CONFIG_ = this.user?.partner?.config?.cms?.sections;
    const USERS = CONFIG_?.users?.table?.columns;
    const SOURCE_URL = USERS?.id?.links?.props?.wallets;
    this.DISPLAY_FIELDS = SOURCE_URL.source?.display_fields;
    this.INITIAL_FILTERS = SOURCE_URL?.source?.initial_filters;
    this.WALLET_URL = SOURCE_URL?.source?.endpoint
      .replace('GET /api/', '')
      .trim();
  }

  ngOnInit(): void {
    if (this.details?.device?.user_code) {
      this.getWalletBalances();
    }
  }

  getWalletBalances() {
    let FULL_URL = '';
    if (this.PARTNER_NAME !== 'nextcare') {
      this.params = this.params.set('wallet_type_id', '6,7,8,9,10,11,12,13');
    }

    const DEFAULT_URL = USER_WALLET_BALANCE.replace(
      '{userCode}',
      this.details?.device?.user_code
    );

    if (this.PARTNER_NAME === 'nextcare') {
      FULL_URL =
        SERVER_URL +
        this.WALLET_URL.replace(
          '{{uuid}}',
          this.details.compliance.app_user_uuid
        ) +
        `/?${toQueryParams(this.INITIAL_FILTERS)}`;
    } else {
      FULL_URL = DEFAULT_URL;
    }

    this.dataService
      .fetchData({
        apiUrl: FULL_URL,
        method: 'GET',
        contentType: 'application/json',
        params: this.params,
      })
      .pipe(
        map((response) =>
          _map(response?.results, (item: any) => {
            return {
              ...item,
              total_balance: Number(item.total_balance).toFixed(2),
              available_balance: Number(item.available_balance).toFixed(2),
              on_hold_balance: Number(item.on_hold_balance).toFixed(2),
              uncredited_balance: Number(item.uncredited_balance).toFixed(2),
            };
          })
        )
      )
      .subscribe({
        next: (response) => {
          this.WALLETS = response.filter((i) => i.wallet_type_id !== null);
          if (this.DISPLAY_FIELDS) {
            this.HAS_DISPLAY_FIELDS = true;
            this.WALLETS = this.WALLETS.map((user) =>
              this.DISPLAY_FIELDS.reduce((obj: any, key: any) => {
                obj[key] = user[key];
                return obj;
              }, {})
            );
          } else {
            this.HAS_DISPLAY_FIELDS = false;
          }
        },
      });
  }
}
